import { FuseNavigationModelInterface } from '../../core/components/navigation/navigation.model';
import { User } from '../../core/modelos/user';
import { Funcionalidad } from '../../core/modelos/funcionalidad';
import { TranslateService } from '@ngx-translate/core';

export class FuseNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor(private translate: TranslateService) {
        const usuarioLogueado: User = JSON.parse(sessionStorage.getItem('usuarioLogueado')).usuario;
        if (usuarioLogueado.rol.id === 1) {
            // Si es un adminBOD
            this.model = [
                {
                    'id': 'applications',
                    'title': 'Applicaciones',
                    'translate': 'NAV.APPLICATIONS',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'portfolio',
                            'title': 'Portfolio',
                            'translate': 'NAV.PORTFOLIO.TITULO',
                            'type': 'item',
                            'icon': 'map',
                            'url': '/portfolio'
                        },
                        {
                            'id': 'dashboard',
                            'title': 'Dashboard General',
                            'translate': 'NAV.DASHBOARD.TITULO',
                            'type': 'item',
                            'url': '/general-dashboard',
                            'icon': 'tachometer-alt'
                        },
                        {
                            'id': 'documentos',
                            'title': 'Documentos',
                            'translate': 'NAV.DOCUMENTOS.TITULO',
                            'type': 'item',
                            'url': '/docs/raiz',
                            'icon': 'file'
                        },
                        {
                            'id': 'tickets',
                            'title': 'Tickets',
                            'translate': 'NAV.TICKETS.TITULO',
                            'type': 'item',
                            'url': '/tickets',
                            'icon': 'clipboard'
                        }
                    ]
                },
                {
                    'id': 'gestion',
                    'title': 'Gestión',
                    'translate': 'NAV.GESTION',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'activos',
                            'title': 'Activos',
                            'translate': 'NAV.ACTIVOS.TITULO',
                            'type': 'item',
                            'url': '/activos',
                            'icon': 'clipboard'
                        },
                        {
                            'id': 'clientes',
                            'title': 'Clientes',
                            'translate': 'NAV.CLIENTES.TITULO',
                            'type': 'item',
                            'url': '/clientes',
                            'icon': 'list-ol'
                        },
                        {
                            'id': 'usuarios',
                            'title': 'Usuarios',
                            'translate': 'NAV.USUARIOS.TITULO',
                            'type': 'item',
                            'url': '/usuarios',
                            'icon': 'users'
                        },
                        {
                            'id': 'sociedades',
                            'title': 'Sociedades',
                            'translate': 'NAV.SOCIEDADES.TITULO',
                            'type': 'item',
                            'url': '/sociedades',
                            'icon': 'building'
                        }

                    ]
                }
            ];
        }
        else if (usuarioLogueado.rol.id === 2) {
            // Si es un adminCliente
            this.model = [
                {
                    'id': 'applications',
                    'title': 'Applicaciones',
                    'translate': 'NAV.APPLICATIONS',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'portfolio',
                            'title': 'Portfolio',
                            'translate': 'NAV.PORTFOLIO.TITULO',
                            'type': 'item',
                            'icon': 'map',
                            'url': '/portfolio'
                        },
                        {
                            'id': 'dashboard',
                            'title': 'Dashboard General',
                            'translate': 'NAV.DASHBOARD.TITULO',
                            'type': 'item',
                            'url': '/general-dashboard',
                            'icon': 'tachometer-alt'
                        },
                        {
                            'id': 'documentos',
                            'title': 'Documentos',
                            'translate': 'NAV.DOCUMENTOS.TITULO',
                            'type': 'item',
                            'url': '/docs/raiz',
                            'icon': 'file'
                        },
                        {
                            'id': 'tickets',
                            'title': 'Tickets',
                            'translate': 'NAV.TICKETS.TITULO',
                            'type': 'item',
                            'url': '/tickets',
                            'icon': 'clipboard'
                        }
                    ]
                },
                {
                    'id': 'gestion',
                    'title': 'Gestión',
                    'translate': 'NAV.GESTION',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'activos',
                            'title': 'Activos',
                            'translate': 'NAV.ACTIVOS.TITULO',
                            'type': 'item',
                            'url': '/activos',
                            'icon': 'clipboard'
                        },
                        {
                            'id': 'usuarios',
                            'title': 'Usuarios',
                            'translate': 'NAV.USUARIOS.TITULO',
                            'type': 'item',
                            'url': '/usuarios',
                            'icon': 'users'
                        },
                        {
                            'id': 'sociedades',
                            'title': 'Sociedades',
                            'translate': 'NAV.SOCIEDADES.TITULO',
                            'type': 'item',
                            'url': '/sociedades',
                            'icon': 'building'
                        }

                    ]
                }
            ];
        }
        else {
            // Debo tener en cuenta las funcionalidades a las que tiene acceso este usuario cliente
           /*  const menuChildren = [];
            let child;
            usuarioLogueado.funcionalidades.forEach(funcionalidad => {
                switch (funcionalidad.id) {
                    case 1:
                        // funcionalidad.nombre = Asset portfolio
                        child = {
                            'id': 'portfolio',
                            'title': 'Portfolio',
                            'translate': 'NAV.PORTFOLIO.TITLE',
                            'type': 'item',
                            'icon': 'location_on',
                            'url': '/portfolio'
                        };
                        break;
                    case 2:
                        // funcionalidad.nombre = Project Dashboard
                        child = {
                            'id': 'dashboard',
                            'title': 'Dashboard General',
                            'translate': 'NAV.DASHBOARD.TITULO',
                            'type': 'item',
                            'url': '/general-dashboard',
                            'icon': 'insert_chart'
                        };
                        break;
                    case 3:
                        // funcionalidad.nombre = Document folder browser
                        child = {
                            'id': 'documentos',
                            'title': 'Documentos',
                            'translate': 'NAV.DOCUMENTOS.TITULO',
                            'type': 'item',
                            'url': '/docs/raiz',
                            'icon': 'description'
                        };
                        break;
                    case 4:
                        // funcionalidad.nombre = BIM Viewer

                        break;
                    case 5:
                        // funcionalidad.nombre = Soporte técnico

                        break;
                }
                menuChildren.push(child);
            });
            this.model = [];
            // No voy a incluir el menu padre llamado aplicaciones si el usuario no tiene acceso a ninguna
            if (menuChildren.length > 0) {
                this.model.push({
                    'id': 'applications',
                    'title': 'Applicaciones',
                    'translate': 'NAV.APPLICATIONS',
                    'type': 'group',
                    'children': menuChildren
                });
            }
            this.model.push(
                {
                    'id': 'gestion',
                    'title': 'Gestión',
                    'translate': 'NAV.GESTION',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'activos',
                            'title': 'Activos',
                            'translate': 'NAV.ACTIVOS.TITULO',
                            'type': 'item',
                            'url': '/activos',
                            'icon': 'business'
                        }
                    ]
                }
            ); */

            this.model = [
                {
                    'id': 'applications',
                    'title': this.translate.instant('NAV.APPLICATIONS'),
                    // 'translate': 'NAV.APPLICATIONS',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'portfolio',
                            'title': 'Portfolio',
                            'translate': 'NAV.PORTFOLIO.TITULO',
                            'type': 'item',
                            'icon': 'map',
                            'url': '/portfolio'
                        },

                        {
                            'id': 'documentos',
                            'title': this.translate.instant('NAV.DOCUMENTOS.TITULO'),
                            // 'translate': 'NAV.DOCUMENTOS.TITULO',
                            'type': 'item',
                            'url': '/docs/raiz',
                            'icon': 'file'
                        },
                        {
                            'id': 'tickets',
                            'title':  this.translate.instant('NAV.TICKETS.TITULO'),
                            // 'translate': 'NAV.TICKETS.TITULO',
                            'type': 'item',
                            'url': '/tickets',
                            'icon': 'clipboard'
                        }
                    ]
                },
                {
                    'id': 'gestion',
                    'title': this.translate.instant('NAV.GESTION'),
                    // 'translate': 'NAV.GESTION',
                    'type': 'group',
                    'children': [
                        {
                            'id': 'activos',
                            'title': this.translate.instant('NAV.ACTIVOS.TITULO'),
                            // 'translate': ,
                            'type': 'item',
                            'url': '/activos',
                            'icon': 'clipboard'
                        }
                    ]
                }
            ];
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/main/navigation/navigation.model.ts